/* tff-a11y.js — a11y 09-29. Accessibility layer for thefuturefiles.com (WCAG 2.2 AA).
   Loaded last, after theme.js and tff-predictions.js. Everything here is ADDITIVE: it names
   controls, reports state, manages focus for the drawers/dialogs and adds the two user settings
   (keyboard shortcuts on/off — SC 2.1.4; animations on/off — SC 2.2.2 / 2.3.3).
   It never touches the dev gate: nothing inside #ffGate is read, changed or focused, and the gate's
   own capture-phase key blocker still runs first. Safe to remove: delete this file and its
   <script> tag in layout/theme.liquid. */
(function () {
  'use strict';
  var d = document, html = d.documentElement;
  function $(id) { return d.getElementById(id); }
  function inGate(el) { return !!(el && el.closest && el.closest('#ffGate')); }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function attr(el, k, v) { if (el && el.getAttribute(k) !== String(v)) el.setAttribute(k, v); }
  function visible(el) { if (!el || !el.isConnected) return false; var r = el.getBoundingClientRect(); if (!r.width && !r.height) return false; var cs = getComputedStyle(el); return cs.visibility !== 'hidden' && cs.display !== 'none'; }
  var rmq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  /* ── 1. one polite live region for announcements (4.1.3) ───────────────────────────────── */
  var live = d.createElement('div');
  live.id = 'ffA11yLive'; live.className = 'ff-sr';
  live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite'); live.setAttribute('aria-atomic', 'true');
  d.body.appendChild(live);
  var liveT = 0;
  function announce(msg) { clearTimeout(liveT); live.textContent = ''; liveT = setTimeout(function () { live.textContent = msg; }, 150); }
  window.ffAnnounce = announce;

  /* ── 2. Enter / Space on role=button elements that are not real buttons (2.1.1) ─────────── */
  d.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!t || !t.matches || inGate(t)) return;
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    if (!t.matches('[role="button"]:not(button):not(a):not(input):not(summary)')) return;
    e.preventDefault(); e.stopPropagation();
    t.click();
  }, true);

  /* ── 3. single-key shortcuts (Space/k/j/l, double-arrow) can be turned off and never fire
          while typing or while a control has focus (2.1.4). theme.js asks ffKbdBlocked(). ── */
  window.ffKbdBlocked = function (e) {
    if (ls('tff_kbd') === 'off') return true;
    if (e.ctrlKey || e.metaKey || e.altKey) return true;
    var a = d.activeElement;
    if (!a || a === d.body || a === html) return false;
    if (a.isContentEditable) return true;
    var tag = a.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
    if (a.closest && a.closest('[role="dialog"],[role="menu"]')) return true;
    var key = e.key;
    if (key === ' ' || e.code === 'Space' || key === 'Enter') {
      if (tag === 'BUTTON' || tag === 'A' || tag === 'SUMMARY' || a.hasAttribute('tabindex') || a.getAttribute('role')) return true;
    }
    return false;
  };

  /* ── 4. user settings: shortcuts and animations ────────────────────────────────────────── */
  var twOrig = null;
  function setPlaceholderStatic() {
    ['typewriterText', 'mobileTypewriterText'].forEach(function (id) { var el = $(id); if (el) el.textContent = 'Search transcripts or episodes…'; });
  }
  function applyMotion() {
    var reduce = ls('tff_motion') === 'off' || rmq.matches;
    html.classList.toggle('ff-reduce-motion', reduce);
    try {
      if (reduce) {
        if (!twOrig && typeof window.typeWriterEffect === 'function') { twOrig = window.typeWriterEffect; window.typeWriterEffect = function () {}; }
        try { clearTimeout(typewriterTimeout); } catch (x) {}
        setPlaceholderStatic();
      } else if (twOrig) {
        window.typeWriterEffect = twOrig; twOrig = null;
        try { window.typeWriterEffect(); } catch (x) {}
      }
    } catch (x) {}
    syncToggles();
  }
  function syncToggles() {
    var kOn = ls('tff_kbd') !== 'off', mOn = !html.classList.contains('ff-reduce-motion');
    d.querySelectorAll('[data-ff-toggle="kbd"]').forEach(function (b) { attr(b, 'aria-pressed', kOn ? 'true' : 'false'); var s = b.querySelector('.ff-tog-state'); if (s) s.textContent = kOn ? 'On' : 'Off'; });
    d.querySelectorAll('[data-ff-toggle="motion"]').forEach(function (b) { attr(b, 'aria-pressed', mOn ? 'true' : 'false'); var s = b.querySelector('.ff-tog-state'); if (s) s.textContent = mOn ? 'On' : 'Off'; b.disabled = rmq.matches; if (rmq.matches) b.title = 'Your system asks for reduced motion'; });
  }
  window.ffToggleKbd = function () { ls('tff_kbd', ls('tff_kbd') === 'off' ? 'on' : 'off'); syncToggles(); announce('Keyboard shortcuts ' + (ls('tff_kbd') === 'off' ? 'off' : 'on')); };
  window.ffToggleMotion = function () { ls('tff_motion', html.classList.contains('ff-reduce-motion') ? 'on' : 'off'); applyMotion(); announce('Animations ' + (html.classList.contains('ff-reduce-motion') ? 'off' : 'on')); };
  if (rmq.addEventListener) rmq.addEventListener('change', applyMotion);
  /* JS-driven smooth scrolling honours the setting too */
  (function () {
    function strip(o) { if (o && typeof o === 'object' && html.classList.contains('ff-reduce-motion') && o.behavior === 'smooth') { o = Object.assign({}, o, { behavior: 'auto' }); } return o; }
    var st = Element.prototype.scrollTo, sb = Element.prototype.scrollBy, si = Element.prototype.scrollIntoView;
    if (st) Element.prototype.scrollTo = function (a, b) { return typeof a === 'object' ? st.call(this, strip(a)) : st.apply(this, arguments); };
    if (sb) Element.prototype.scrollBy = function (a, b) { return typeof a === 'object' ? sb.call(this, strip(a)) : sb.apply(this, arguments); };
    if (si) Element.prototype.scrollIntoView = function (a) { return si.call(this, typeof a === 'object' ? strip(a) : a); };
  })();

  /* ── 5. dialogs, drawers and menus: role, name, Escape, focus in / trap / return (2.1.2, 2.4.3) */
  var DLG = [
    { id: 'mobileDrawer', label: 'Menu', modal: true, isOpen: function (e) { return e.classList.contains('open'); }, close: function () { window.toggleMobileDrawer && window.toggleMobileDrawer(); }, triggers: '[onclick="toggleMobileDrawer()"]:not(#mobileDrawerOverlay)', inertClosed: true },
    { id: 'cartModal', label: 'Cart', modal: true, focusIn: 'cartPanel', isOpen: function (e) { return !e.classList.contains('hidden'); }, close: function () { window.toggleCart && window.toggleCart(); }, triggers: '#desktopCartBtn,#mobileCartBtn' },
    { id: 'customRangeModal', label: 'Custom date range', modal: true, isOpen: function (e) { return !e.classList.contains('hidden'); }, close: function () { window.closeCustomRange && window.closeCustomRange(); }, triggers: '#btn-custom' },
    { id: 'fullScreenPlayer', label: 'Now playing', modal: true, isOpen: function (e) { return e.classList.contains('open'); }, close: function () { window.closeFullPlayer && window.closeFullPlayer(); }, triggers: '#miniPlayerOpen', inertClosed: true },
    { id: 'emailModal', label: 'Contact', modal: false, isOpen: function (e) { return !e.classList.contains('hidden'); }, close: function () { window.toggleEmail && window.toggleEmail(); }, triggers: '#nav-email' },
    { id: 'composeModal', label: 'Clips', modal: false, isOpen: function (e) { return !e.classList.contains('hidden'); }, close: function () { window.toggleCompose && window.toggleCompose(); } },
    { id: 'nowPlayingDotsMenu', label: 'Player options', modal: false, menu: true, isOpen: function (e) { return !e.classList.contains('hidden'); }, close: function () { window.toggleNowPlayingMenu && window.toggleNowPlayingMenu(); }, triggers: '[onclick="toggleNowPlayingMenu()"]' }
  ];
  var stack = [];
  /* 10-20 (T120): which kind of input came last. A drawer/dialog opened by touch or mouse is focused as a whole instead of on its first control,
     because iOS WebKit draws the keyboard focus ring (an orange box round the logo) on a control that a script focuses. Keyboard users get the old behaviour. */
  var lastPtr = 0, lastKey = 0;
  ['pointerdown', 'touchstart', 'mousedown'].forEach(function (t) { d.addEventListener(t, function () { lastPtr = Date.now(); }, true); });
  d.addEventListener('keydown', function () { lastKey = Date.now(); }, true);
  function pointerOpened() { return lastPtr > lastKey; }
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"]),[role="button"][tabindex]';
  function focusables(root) { return Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), function (el) { return visible(el) && !el.closest('[inert]'); }); }
  function setupDialog(cfg) {
    var el = $(cfg.id); if (!el) return;
    cfg.el = el;
    var box = cfg.focusIn ? $(cfg.focusIn) || el : el;
    cfg.box = box;
    if (!cfg.menu) { attr(box, 'role', 'dialog'); if (cfg.modal) attr(box, 'aria-modal', 'true'); if (!box.hasAttribute('aria-label') && !box.hasAttribute('aria-labelledby')) attr(box, 'aria-label', cfg.label); }
    if (!box.hasAttribute('tabindex')) box.setAttribute('tabindex', '-1');
    cfg.was = cfg.isOpen(el);
    sync(cfg, true);
    new MutationObserver(function () { sync(cfg, false); }).observe(el, { attributes: true, attributeFilter: ['class', 'style'] });
  }
  function sync(cfg, first) {
    var open = cfg.isOpen(cfg.el);
    if (cfg.triggers) d.querySelectorAll(cfg.triggers).forEach(function (t) { attr(t, 'aria-expanded', open ? 'true' : 'false'); });
    if (cfg.inertClosed) { if (open) cfg.el.removeAttribute('inert'); else cfg.el.setAttribute('inert', ''); }
    if (first || open === cfg.was) { cfg.was = open; return; }
    cfg.was = open;
    if (open) {
      var ae = d.activeElement;
      cfg.opener = (ae && ae !== d.body && !cfg.el.contains(ae)) ? ae : null;
      stack = stack.filter(function (c) { return c !== cfg; }); stack.push(cfg);
      setTimeout(function () {
        if (!cfg.isOpen(cfg.el)) return;
        if (cfg.el.contains(d.activeElement)) return;
        var f = focusables(cfg.box);
        (pointerOpened() ? cfg.box : (f[0] || cfg.box)).focus({ preventScroll: true });
      }, 80);
    } else {
      stack = stack.filter(function (c) { return c !== cfg; });
      var o = cfg.opener; cfg.opener = null;
      var ae2 = d.activeElement;
      if (o && o.isConnected && (!ae2 || ae2 === d.body || cfg.el.contains(ae2))) setTimeout(function () { if (visible(o)) o.focus({ preventScroll: true }); }, 60);
    }
  }
  d.addEventListener('keydown', function (e) {
    if (inGate(e.target)) return;
    var top = null;
    for (var i = stack.length - 1; i >= 0; i--) { if (stack[i].isOpen(stack[i].el)) { top = stack[i]; break; } }
    if (!top) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopPropagation(); top.close(); return; }
    if (e.key === 'Tab' && top.modal) {
      var f = focusables(top.box); if (!f.length) { e.preventDefault(); top.box.focus(); return; }
      var first = f[0], last = f[f.length - 1], a = d.activeElement;
      if (!top.box.contains(a)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && (a === first || a === top.box)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    }
  }, true);

  /* things that sit off-screen when "hidden" must not take focus either (2.4.3, 2.4.11) */
  function offscreenWatch(id, isShown) {
    var el = $(id); if (!el) return;
    var f = function () { if (isShown(el)) el.removeAttribute('inert'); else el.setAttribute('inert', ''); };
    f(); new MutationObserver(f).observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  /* ── 6. control state: play/pause, mute, shuffle, theme, filters, sidebar (4.1.2) ────────── */
  var player = $('audioElement');
  function syncPlay() {
    if (!player) return;
    var playing = !player.paused && !player.ended;
    ['headerPlayBtn', 'mobileHeaderPlayBtn', 'miniPlayBtn', 'fullPlayBtn', 'ffPlayBtn'].forEach(function (id) { attr($(id), 'aria-label', playing ? 'Pause' : 'Play'); });
  }
  function fmt(s) { s = Math.max(0, Math.floor(s || 0)); var h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60), x = s % 60; return (h ? h + ':' + String(m).padStart(2, '0') : m) + ':' + String(x).padStart(2, '0'); }
  var lastVT = 0;
  function syncTime() {
    if (!player) return; var now = Date.now(); if (now - lastVT < 1000) return; lastVT = now;
    var txt = fmt(player.currentTime) + ' of ' + (isFinite(player.duration) ? fmt(player.duration) : 'unknown');
    attr($('ffScrub'), 'aria-valuetext', txt); attr($('fullScrubber'), 'aria-valuetext', txt);
  }
  if (player) {
    ['play', 'playing', 'pause', 'ended', 'emptied'].forEach(function (ev) { player.addEventListener(ev, syncPlay); });
    player.addEventListener('timeupdate', syncTime);
    player.addEventListener('loadedmetadata', function () { lastVT = 0; syncTime(); });
    player.addEventListener('volumechange', function () { attr($('ffMuteBtn'), 'aria-label', player.muted ? 'Unmute' : 'Mute'); var v = $('ffVol'); if (v) attr(v, 'aria-valuetext', Math.round(player.volume * 100) + '%'); });
  }
  function syncShuffle() {
    var on = false; try { on = !!isShuffleOn; } catch (e) { var b = $('shuffleBtn'); on = !!(b && b.classList.contains('text-orange-500')); }
    ['shuffleBtn', 'mobileActionShuffleBtn', 'fullShuffleBtn'].forEach(function (id) { attr($(id), 'aria-pressed', on ? 'true' : 'false'); });
  }
  function syncTheme() { d.querySelectorAll('[onclick="toggleTheme()"]').forEach(function (b) { attr(b, 'aria-pressed', html.classList.contains('dark') ? 'true' : 'false'); }); }
  function syncChips() { d.querySelectorAll('#filterBar .filter-chip').forEach(function (b) { attr(b, 'aria-pressed', b.classList.contains('active-chip') ? 'true' : 'false'); }); }
  function syncSidebar() { var s = $('sidebar'); var t = d.querySelector('[onclick="toggleSidebar()"]'); if (s && t) attr(t, 'aria-expanded', s.classList.contains('w-64') ? 'true' : 'false'); }
  function syncArchives() { var s = $('archivesSection'); var n = $('nav-archives'); if (s && n) attr(n, 'aria-expanded', s.style.display === 'block' ? 'true' : 'false'); }

  /* ── 7. announce what starts playing, and the result count after a search (4.1.3) ───────── */
  var lastTitle = null;
  function watchTitle() {
    var t = $('playerTitle'); if (!t) return;
    lastTitle = t.textContent;
    new MutationObserver(function () {
      var s = (t.textContent || '').trim();
      if (s && s !== lastTitle && s !== 'Select an episode') announce('Now playing: ' + s);
      lastTitle = s;
    }).observe(t, { childList: true, characterData: true, subtree: true });
  }

  /* ── 8. sweep for dynamic content: names for icon-only controls, labels for bare inputs,
          alt on decorative images (1.1.1, 1.3.1, 4.1.2). Runs on DOM changes, debounced. ─── */
  function nameOf(el) { return (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby') || (el.textContent || '').replace(/[×✕\s]/g, '')); }
  function sweep(root) {
    root = root || d.body;
    root.querySelectorAll('button, a[href], [role="button"]').forEach(function (b) {
      if (inGate(b) || nameOf(b)) return;
      var t = b.getAttribute('title');
      if (!t && b.classList.contains('ff-ask-x')) t = 'Close';
      if (!t) { var i = b.querySelector('i[class*="fa-"]'); if (i) { var m = /fa-(times|xmark|close)\b/.test(i.className) ? 'Close' : /fa-search\b/.test(i.className) ? 'Search' : null; t = m; } }
      if (t) b.setAttribute('aria-label', t);
    });
    root.querySelectorAll('input:not([type="hidden"]):not([aria-label]):not([aria-labelledby]), select:not([aria-label]):not([aria-labelledby]), textarea:not([aria-label])').forEach(function (inp) {
      if (inGate(inp) || inp.closest('label')) return;
      if (inp.id && d.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(inp.id) : inp.id) + '"]')) return;
      var ctl = inp.closest('.ff-ctl'); var lab = ctl && ctl.querySelector('.ff-ctl-l');
      var n = (lab && lab.textContent.trim()) || inp.getAttribute('placeholder') || inp.getAttribute('title') || (inp.name === 'q' ? 'Search' : '');
      if (n) inp.setAttribute('aria-label', n);
    });
    root.querySelectorAll('img:not([alt])').forEach(function (im) { if (!inGate(im)) im.setAttribute('alt', ''); });
    root.querySelectorAll('i.fas, i.fab, i.far').forEach(function (i) { if (!i.hasAttribute('aria-hidden')) i.setAttribute('aria-hidden', 'true'); });
    root.querySelectorAll('#ffAcctPanel .ff-acct-note, #ffAcctManageMsg, #ffPlayerStatus').forEach(function (s) { if (!s.hasAttribute('role')) { s.setAttribute('role', 'status'); s.setAttribute('aria-live', 'polite'); } });
    syncChips(); syncShuffle();
  }
  var sweepT = 0;
  function queueSweep() { if (sweepT) return; sweepT = setTimeout(function () { sweepT = 0; try { sweep(); } catch (e) {} }, 250); }

  /* ── 9. keep a focused control clear of the sticky header / fixed bottom bars (2.4.11) ────── */
  function obstruct() {
    var top = 0, bottom = window.innerHeight;
    ['mobileBottomNav', 'miniPlayer'].forEach(function (id) { var el = $(id); if (el && visible(el)) { var r = el.getBoundingClientRect(); if (r.top < bottom && r.top > window.innerHeight / 2) bottom = r.top; } });
    ['mobileHeader', 'mobileTopControls', 'filterBarWrapper'].forEach(function (id) { var el = $(id); if (el && visible(el)) { var cs = getComputedStyle(el); if (cs.position === 'sticky' || cs.position === 'fixed') { var r = el.getBoundingClientRect(); if (r.bottom > top && r.bottom < window.innerHeight / 2) top = r.bottom; } } });
    return { top: top, bottom: bottom };
  }
  d.addEventListener('focusin', function (e) {
    var el = e.target, mc = $('mainContainer');
    if (!mc || !mc.contains(el) || el === mc) return;
    requestAnimationFrame(function () {
      var r = el.getBoundingClientRect(), o = obstruct();
      if (r.bottom > o.bottom - 8) mc.scrollBy(0, r.bottom - o.bottom + 16);
      else if (r.top < o.top + 8 && r.bottom > 0) mc.scrollBy(0, r.top - o.top - 16);
    });
  });

  /* ── 10. page title follows the in-page tab (2.4.2) ──────────────────────────────────────── */
  var baseTitle = d.title;
  function wrapShowTab() {
    var orig = window.ffShowTab; if (typeof orig !== 'function' || orig.__a11y) return;
    var w = function (tab) {
      var r = orig.apply(this, arguments);
      var t = tab === 'predictions' ? 'Markets — The Future Files' : tab === 'app' ? 'Get the app — The Future Files' : tab === 'discs' ? 'Market — The Future Files' : tab === 'email' ? 'Playlists / Clips — The Future Files' : baseTitle;
      if (window.ffAtHome ? window.ffAtHome() : window.location.pathname === '/') d.title = t;
      return r;
    };
    w.__a11y = true; window.ffShowTab = w;
  }

  /* ── boot ─────────────────────────────────────────────────────────────────────────────── */
  function boot() {
    DLG.forEach(setupDialog);
    offscreenWatch('miniPlayer', function (el) { return el.classList.contains('visible'); });
    offscreenWatch('mobileShowMoreBtn', function (el) { return el.classList.contains('visible'); });
    offscreenWatch('backToTopBtn', function (el) { return !el.classList.contains('translate-y-48'); });
    /* the collapsed Markets group is aria-hidden: its rows must not be focusable while it is shut */
    (function () {
      var g = $('nav-markets-group'); if (!g) return;
      var f = function () { var open = g.classList.contains('open'); if (open) g.removeAttribute('inert'); else g.setAttribute('inert', ''); g.querySelectorAll('[role="button"]').forEach(function (r) { r.setAttribute('tabindex', open ? '0' : '-1'); }); };
      f(); new MutationObserver(f).observe(g, { attributes: true, attributeFilter: ['class'] });
    })();
    var mo = function (id, fn, opts) { var el = id === 'html' ? html : $(id); if (el) new MutationObserver(fn).observe(el, opts || { attributes: true, attributeFilter: ['class', 'style'] }); };
    mo('html', function () { syncTheme(); });
    mo('sidebar', syncSidebar);
    mo('archivesSection', syncArchives);
    mo('shuffleBtn', syncShuffle);
    watchTitle(); wrapShowTab();
    syncPlay(); syncTheme(); syncSidebar(); syncArchives();
    applyMotion();
    sweep();
    /* ignore the clock/progress text that changes several times a second while audio plays */
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target; t = t.nodeType === 1 ? t : t.parentElement;
        if (t && !(t.closest && t.closest('footer, #miniPlayer, #fullScreenPlayer, #ffA11yLive, .loading-percent, #ffPlayerBar'))) { queueSweep(); return; }
      }
    }).observe(d.body, { childList: true, subtree: true });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', function () { wrapShowTab(); applyMotion(); queueSweep(); });
})();
